<template>
  <div id="the-quote">
    <b-container class="quote-container">
      <ImageGallery
        class="quote-gallery"
        style="margin-top: 40px"
        :data="[
          require('@/assets/images/galleries/WomansMonth/Womens-Month-01.jpg'),
          require('@/assets/images/galleries/WomansMonth/Womens-Month-02.jpg'),
          require('@/assets/images/galleries/WomansMonth/Womens-Month-03.jpg'),
        ]"
        :idString="'theartist'"
        :imageDimensions="
          !global.isMobile
            ? {
                height: '417.59px',
                width: '696px',
              }
            : { width: '696px' }
        "
      />
      <div class="qtext-container">
        <div class="q-side">
          <div class="rotate-text">
            <span>KATE LYNN LEWIS</span>
            <div class="q-spacer" />
          </div>
          <svg width="32" height="19" viewBox="0 0 32 19" xmlns="http://www.w3.org/2000/svg" v-bind:class="'qquote'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.75 19l8.098-19h-6.29L0 19h9.75zm14.152 0L32 0h-6.29L14.152 19h9.75z" fill="#9EA5FD" fill-rule="nonzero"/></svg>
        </div>
        <p class="quote-text">
          It doesn’t have to be considered objectification or sexualization to
          represent the female body or use verbiage that, when in a certain
          context, might be derogatory. I do believe that the pendulum has the
          ability to swing too far in one direction or the other and I think
          it’s important to remember intention and to take back jargon as our
          own. Yes, we are chicks. Yes, we are babes. Yes, we are proud of what
          we have and what we will continue to accomplish in these beautiful
          bodies and brains.
        </p>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ImageGallery from "@/components/global/ImageGallery";

export default {
  name: "TheQuote",
  components: {
    ImageGallery,
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
#the-quote {
  padding-bottom: 100px;
  padding-left: 19px;
  padding-right: 19px;
  @media (max-width: $md) {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 50px;
  }

  .quote-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding-left: 48px;
    padding-top: 60px;
    padding-right: 0;
    padding-bottom: 70px;
    background-image: url("~@/assets/images/bg/Purple-Texture-BG.jpg");
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: center;

    @media (max-width: $lg) {
      padding-right: 20px;
      padding-left: 20px;
    }
  }
  @media (max-width: $md) {
    .qquote {
      display: none;
    }
  }
  .qtext-container {
    position: relative;
    margin-top: 30px;
    max-width: 100%;
    .q-side {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      position: absolute;
      left: 0;
      top: 0;
      transform: translateX(-100%);
      padding-right: 18px;
      padding-top: 10px;
      @media (max-width: $lg) {
        // position: static;
        // transform: none;
        transform: translateX(-57%);
      }
      @media (max-width: $md) {
        position: static;
        transform: none;
      }
      .rotate-text {
        transform: rotate(270deg);
        transform-origin: 85% 65%;
        @media (max-width: $lg) {
          // transform: none;
        }
        @media (max-width: $md) {
          transform: none;
        }
        // padding-bottom: 24.5px;
        span {
          font-family: Poppins-Bold;
          font-size: 20px;
          color: #ffffff;
          letter-spacing: 0;
          text-align: center;
          line-height: 24px;
        }
        .q-spacer {
          width: 100%;
          height: 2px;
          background: #9ea5fd;
          margin-top: 7.5px;
        }
        img {
          width: 32px;
          height: 19px;
        }
      }
    }
  }

  .quote-gallery {
    width: 696px;
    max-width: 100%;
    img {
      width: 696px !important;
      height: 417.59px !important;
      object-fit: cover;
    }
  }
  .quote-text {
    width: 696px;
    max-width: 100%;
    text-align: start;
    font-family: Poppins-MediumItalic;
    font-size: 24px;
    color: #ffffff;
    letter-spacing: -1px;
    line-height: 42px;
    @media (max-width: $lg) {
      padding-left: 95px;
    }
    @media (max-width: $md) {
      padding-left: 0;
      font-size: 20px;
      margin-top: 20px;
      &::before {
        content: url("~@/assets/images/icons/Close-Quote.svg");
        min-width: 32px;
        min-height: 19px;
        padding-left: 12px;
      }
    }
    &::after {
      content: url("~@/assets/images/icons/Close-Quote.svg");
      min-width: 32px;
      min-height: 19px;
      padding-left: 12px;
    }
  }

  p {
    width: 852px;
    max-width: 100%;
    font-family: AvenirNext-Medium;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 31px;
  }
  .no-margin {
    margin: 0 !important;
  }
}
</style>

<style lang="scss">
#the-quote {
  .hooper-indicators {
    .hooper-indicator {
      height: 10px;
      width: 10px;
      border-radius: 50%;
      margin: 0 4px;
      outline: none;
      &:hover {
        cursor: pointer;
        background-color: #9ea5fd;
      }
    }

    .is-active {
      background-color: #9ea5fd;
    }
  }
  .navArrow {
    &:hover {
      path {
        fill: #9ea5fd !important;
      }
    }
  }
}
</style>